import { TRANSITION_WORKFLOW } from '@plone/volto/constants/ActionTypes';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

/**
 * `transitionWorkflow` do core com comentário: o `@workflow` do plone.restapi
 * aceita `comment`, que vai para o histórico e para a notificação de quem
 * precisa agir em seguida. Mesmo `type` do core, para o reducer de workflow
 * reagir igual.
 */
export function transitionWorkflowComComentario(url: string, comment = '') {
  return {
    type: TRANSITION_WORKFLOW,
    request: {
      op: 'post',
      path: flattenToAppURL(url),
      data: { include_children: false, ...(comment ? { comment } : {}) },
    },
  };
}
